module.exports = __webpack_public_path__ + "static/img/31.08bc803.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/31.jpg
// module id = Eo3R
// module chunks = 1